import { isSSR } from './ssrUtils'
import { isNil } from './checks'

export const setLocalStorage = (key: string, value: unknown): void => {
  if (isSSR() || isNil(window.localStorage)) return

  localStorage.setItem(key, JSON.stringify(value))
}

export const getLocalStorage = (key: string): unknown | null => {
  if (isSSR() || isNil(window.localStorage)) return null
  const localStorageValue = localStorage.getItem(key)
  if (isNil(localStorageValue)) return null
  return JSON.parse(localStorageValue)
}
